"use client"

import { useAboutTextMutation } from '@/shared/api-rtk/index.js'
import { useState } from 'react'
import { useEffect } from 'react'

export function CookieWarning() {
    const [getText] = useAboutTextMutation()
    const [aboutText, setAboutText] = useState('')
    const [close, setClose] = useState(false)

    useEffect(() => {
        setClose(JSON.parse(localStorage.getItem('cookie-warning')) ?? false)
    }, [])

    useEffect(() => {
        localStorage.setItem('cookie-warning', JSON.stringify(close))
    }, [close])

    useEffect(() => {
        getText(3)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setAboutText(res.data.value)
                }
            })
            .catch((err) => {
                console.error('Ошибка загрузки текста:', err)
            })

        const handler = function(event) {
            if (event.key === 'F5' && event.ctrlKey) {
                console.log('Нажат Ctrl + F5');
                // Сбрасываем флаг подсказки, чтобы она показалась снова
                localStorage.removeItem('cookie-warning');
            }
        };
        window.addEventListener('keydown', handler);

        return () => {
            window.removeEventListener('keydown', handler);
        };
    }, [])

    const onClick = () => {
        setClose(true)
    }

    if (close || aboutText === '') return null

    return (
        <section className='cookie-warning-containter'>
            <div onClick={() => setAboutText('')} className='close-btn'></div>
            <div>
                {aboutText && aboutText}
            </div>
            <button onClick={onClick}>Ок</button>
        </section>
    )
}
